import Route from '@ember/routing/route';

/**
 * TIO Reimagined Parent Route
 *
 * This route serves as the container for the reimagined unified
 * financial wellness experience. Child routes include:
 * - /reimagined/home - Unified dashboard
 * - /reimagined/loans - Loans management
 * - /reimagined/benefits - Benefits hub
 *
 * @see workspace/plans/reimagined/12-demo-progress.md
 */
export default class AuthenticatedReimagined extends Route {}
